export default "__VITE_ASSET__CFJue4ZW__"